
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21.1899 21.19L20.4099 20.41L17.9999 18L13.4099 13.41L3.58989 3.59002L2.80989 2.81002C2.41989 2.42002 1.78989 2.42002 1.39989 2.81002C0.999895 3.20002 0.999895 3.83002 1.38989 4.22002L2.99989 5.83002V19C2.99989 20.1 3.89989 21 4.99989 21H18.1699L19.7799 22.61C20.1699 23 20.7999 23 21.1899 22.61C21.5799 22.22 21.5799 21.58 21.1899 21.19ZM6.01989 18C5.59989 18 5.36989 17.52 5.62989 17.19L8.11989 13.99C8.31989 13.74 8.69989 13.73 8.89989 13.98L10.9999 16.51L12.1699 15L15.1699 18H6.01989ZM20.9999 18.17L5.82989 3.00002H18.9999C20.0999 3.00002 20.9999 3.90002 20.9999 5.00002V18.17Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-image-not-supported`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconImageNotSupported

    ```js
    <b-new-b-icon-image-not-supported />
    ```
</docs>


